export default __webpack_public_path__ + "static/clayton-89140f5862e85b0abd73cdf5b6c1ce1e.jpg";